import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { integracionService } from '../services/integracionService'

export function useIntegraciones() {
  return useQuery({ queryKey: ['integraciones'], queryFn: integracionService.estado })
}

/**
 * Permisos del token en Puente, bajo demanda: el validador de Puente admite una consulta
 * cada 5 minutos por IP (el backend guarda la respuesta ese tiempo).
 */
export function usePermisosPuente() {
  return useMutation({ mutationFn: integracionService.permisosPuente, retry: false })
}

/** Consulta a Puente bajo demanda (cada una gasta cuota de UCampus: no se cachea ni se reintenta). */
export function useConsultaPuente() {
  return useMutation({ mutationFn: (rut: number) => integracionService.personaPuente(rut), retry: false })
}

/** Cuántas hay en Factos, bajo demanda (consulta la API de Factos). */
export function useResumenFactos() {
  return useMutation({ mutationFn: integracionService.resumenFactos, retry: false })
}

/** Registrar las cuentas: cambia la lista de usuarios. */
export function useImportarFactos() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: integracionService.importarFactos, retry: false, onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }) })
}
